import React, { useEffect, useState, useRef } from 'react';
import { Users, FileText, Plus, Edit2, Check, X, Mail, MessageCircle, AlertCircle, Upload, Download, Trash2, FolderOpen, UserCheck } from 'lucide-react';
import api from '../../api/client';

const TIPO_SOCIO = ['FONDATORE','ORDINARIO','SOSTENITORE','ONORARIO'];
const STATO_SOCIO = ['ATTIVO','SOSPESO','RECEDUTO','ESPULSO'];
const RUOLI_DIRETTIVO = ['','PRESIDENTE','VICEPRESIDENTE','SEGRETARIO','TESORIERE','CONSIGLIERE'];
const TIPO_VERBALE = [
  { id:'ASSEMBLEA_ORDINARIA',     label:'Assemblea Ordinaria',     preavviso:10 },
  { id:'ASSEMBLEA_STRAORDINARIA', label:'Assemblea Straordinaria', preavviso:10 },
  { id:'CONSIGLIO_DIRETTIVO',     label:'Consiglio Direttivo',     preavviso:3  },
];

const fmtData = (d) => d ? new Date(d).toLocaleDateString('it-IT') : '—';
const EMPTY_SOCIO = { nome:'', cognome:'', codice_fiscale:'', data_nascita:'', luogo_nascita:'', indirizzo:'', cap:'', citta:'', provincia:'', email:'', telefono:'', tipo:'ORDINARIO', data_iscrizione: new Date().toISOString().slice(0,10), numero_tessera:'', quota_anno: new Date().getFullYear(), quota_pagata:false, quota_importo:'', data_quota:'', stato:'ATTIVO', ruolo_direttivo:'', note:'' };
const EMPTY_VERBALE = { tipo:'ASSEMBLEA_ORDINARIA', data: new Date().toISOString().slice(0,10), ora_inizio:'', ora_fine:'', luogo:'', modalita:'PRESENZA', presidente:'', segretario:'', ordine_del_giorno:'', presenti_nomi:'', presenti_numero:'', assenti_nomi:'', deleghe:'', quorum_prima:false, delibere:'', note:'', stato:'BOZZA' };

export default function Segreteria() {
  const [tab, setTab]           = useState('soci');
  const [soci, setSoci]         = useState([]);
  const [stats, setStats]       = useState(null);
  const [verbali, setVerbali]   = useState([]);
  const [loading, setLoading]   = useState(false);

  // Filtri
  const [filtroStato, setFiltroStato] = useState('ATTIVO');
  const [filtroTipo, setFiltroTipo]   = useState('');
  const [filtroAnnoV, setFiltroAnnoV] = useState(new Date().getFullYear());
  const [filtroTipoV, setFiltroTipoV] = useState('');

  // Form soci
  const [showFormSocio, setShowFormSocio] = useState(false);
  const [editSocio, setEditSocio]         = useState(null);
  const [formSocio, setFormSocio]         = useState(EMPTY_SOCIO);

  // Form verbali
  const [showFormVerbale, setShowFormVerbale] = useState(false);
  const [editVerbale, setEditVerbale]         = useState(null);
  const [formVerbale, setFormVerbale]         = useState(EMPTY_VERBALE);

  // Dettaglio verbale aperto
  const [verbaleAperto, setVerbaleAperto] = useState(null);
  const [showConvocazione, setShowConvocazione] = useState(false);
  const [canaleConv, setCanaleConv]       = useState('EMAIL');
  const [testoConv, setTestoConv]         = useState('');
  const [loadingConv, setLoadingConv]     = useState(false);

  // Comunicazione socio
  const [socioComm, setSocioComm]   = useState(null);
  const [canaleComm, setCanaleComm] = useState('EMAIL');
  const [motivoEscl, setMotivoEscl] = useState('');
  const [testoComm, setTestoComm]   = useState('');

  // Richieste socio (admin)
  const [richieste, setRichieste]             = useState([]);
  const [filtroStR, setFiltroStR]             = useState('PENDENTE');
  const [noteAdmin, setNoteAdmin]             = useState({});
  const [processingR, setProcessingR]         = useState(null);

  // Documenti ASD
  const [tipiTemplate, setTipiTemplate]   = useState([]);
  const [templates, setTemplates]         = useState([]);
  const [documenti, setDocumenti]         = useState([]);
  const [docFiltroTipo, setDocFiltroTipo] = useState('');
  const [docFiltroAnno, setDocFiltroAnno] = useState(new Date().getFullYear());
  const [genForm, setGenForm]             = useState({ template_id:'', socio_id:'', verbale_id:'' });
  const [generando, setGenerando]         = useState(false);
  const uploadRef                         = useRef(null);
  const [uploadForm, setUploadForm]       = useState({ nome:'', tipo:'DOMANDA_ISCRIZIONE', descrizione:'' });
  const [uploadFile, setUploadFile]       = useState(null);
  const [uploading, setUploading]         = useState(false);
  const [docMsg, setDocMsg]               = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filtroStato) params.stato = filtroStato;
      if (filtroTipo)  params.tipo  = filtroTipo;
      const [s, st] = await Promise.all([
        api.get('/segreteria/soci', { params }),
        api.get('/segreteria/soci/stats'),
      ]);
      setSoci(s.data);
      setStats(st.data);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  const loadVerbali = async () => {
    const params = {};
    if (filtroAnnoV) params.anno = filtroAnnoV;
    if (filtroTipoV) params.tipo = filtroTipoV;
    const r = await api.get('/segreteria/verbali', { params });
    setVerbali(r.data);
  };

  useEffect(() => { if (tab === 'soci') load(); }, [tab, filtroStato, filtroTipo]);
  useEffect(() => { if (tab === 'verbali') loadVerbali(); }, [tab, filtroAnnoV, filtroTipoV]);
  useEffect(() => {
    if (tab === 'documenti') {
      loadDocs();
      if (!soci.length)    load();
      if (!verbali.length) loadVerbali();
    }
  }, [tab, docFiltroTipo, docFiltroAnno]);
  useEffect(() => { if (tab === 'richieste') loadRichieste(); }, [tab, filtroStR]);

  const salvaSocio = async (e) => {
    e.preventDefault();
    if (editSocio) await api.put(`/segreteria/soci/${editSocio.id}`, formSocio);
    else await api.post('/segreteria/soci', formSocio);
    setShowFormSocio(false);
    setEditSocio(null);
    setFormSocio(EMPTY_SOCIO);
    load();
  };

  const salvaVerbale = async (e) => {
    e.preventDefault();
    if (editVerbale) await api.put(`/segreteria/verbali/${editVerbale.id}`, formVerbale);
    else await api.post('/segreteria/verbali', formVerbale);
    setShowFormVerbale(false);
    setEditVerbale(null);
    setFormVerbale(EMPTY_VERBALE);
    loadVerbali();
  };

  const apriModificaSocio = (s) => {
    setEditSocio(s);
    setFormSocio({ ...s, data_nascita: s.data_nascita?.slice(0,10)||'', data_iscrizione: s.data_iscrizione?.slice(0,10)||'', data_quota: s.data_quota?.slice(0,10)||'' });
    setShowFormSocio(true);
  };

  const apriModificaVerbale = (v) => {
    setEditVerbale(v);
    setFormVerbale({ ...v, data: v.data?.slice(0,10)||'' });
    setShowFormVerbale(true);
  };

  const generaConvocazione = async (verbale) => {
    setVerbaleAperto(verbale);
    setShowConvocazione(true);
    setLoadingConv(true);
    try {
      const r = await api.post(`/segreteria/verbali/${verbale.id}/convocazione`, { canale: canaleConv });
      setTestoConv(r.data.testo);
    } catch(e) { console.error(e); }
    finally { setLoadingConv(false); }
  };

  const aggiornaCanaleConv = async (canale) => {
    setCanaleConv(canale);
    if (!verbaleAperto) return;
    setLoadingConv(true);
    try {
      const r = await api.post(`/segreteria/verbali/${verbaleAperto.id}/convocazione`, { canale });
      setTestoConv(r.data.testo);
    } catch(e) {} finally { setLoadingConv(false); }
  };

  const copiaConvocazione = () => {
    navigator.clipboard.writeText(testoConv);
    alert('Testo copiato negli appunti!');
  };

  const apriWhatsapp = () => {
    const encoded = encodeURIComponent(testoConv);
    window.open(`https://wa.me/?text=${encoded}`, '_blank');
  };

  const generaEsclusione = async (socio) => {
    setSocioComm(socio);
    setMotivoEscl('');
    setTestoComm('');
  };

  const aggiornaTestoEsclusione = async () => {
    if (!socioComm || !motivoEscl) return;
    const r = await api.post(`/segreteria/soci/${socioComm.id}/esclusione`, { motivo: motivoEscl, canale: canaleComm });
    setTestoComm(r.data.testo);
  };

  const loadDocs = async () => {
    const params = {};
    if (docFiltroTipo) params.tipo = docFiltroTipo;
    if (docFiltroAnno) params.anno = docFiltroAnno;
    const [ti, te, do_] = await Promise.all([
      api.get('/segreteria/docs/tipi'),
      api.get('/segreteria/docs/template'),
      api.get('/segreteria/docs', { params }),
    ]);
    setTipiTemplate(ti.data);
    setTemplates(te.data);
    setDocumenti(do_.data);
  };

  const uploadTemplate = async (e) => {
    e.preventDefault();
    if (!uploadFile) return;
    setUploading(true);
    try {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const base64 = ev.target.result.split(',')[1];
        await api.post('/segreteria/docs/template', {
          fileData: base64,
          fileName: uploadFile.name,
          nome: uploadForm.nome || uploadFile.name,
          tipo: uploadForm.tipo,
          descrizione: uploadForm.descrizione,
        });
        setUploadFile(null); setUploadForm({ nome:'', tipo:'DOMANDA_ISCRIZIONE', descrizione:'' });
        if (uploadRef.current) uploadRef.current.value = '';
        setDocMsg('Template caricato!'); setTimeout(()=>setDocMsg(''), 3000);
        loadDocs();
      };
      reader.readAsDataURL(uploadFile);
    } catch(err) {
      setDocMsg('✗ ' + (err.response?.data?.error || 'Errore upload'));
      setTimeout(()=>setDocMsg(''), 4000);
    } finally { setUploading(false); }
  };

  const eliminaTemplate = async (id, nome) => {
    if (!window.confirm(`Eliminare il template "${nome}"?`)) return;
    await api.delete(`/segreteria/docs/template/${id}`);
    loadDocs();
  };

  const scaricaTemplate = (id) => {
    window.open(`${api.defaults.baseURL}/segreteria/docs/template/${id}/download`, '_blank');
  };

  const generaDocumento = async (e) => {
    e.preventDefault();
    if (!genForm.template_id) return;
    setGenerando(true);
    try {
      const body = { template_id: genForm.template_id };
      if (genForm.socio_id)   body.socio_id   = genForm.socio_id;
      if (genForm.verbale_id) body.verbale_id = genForm.verbale_id;
      const resp = await api.post('/segreteria/docs/genera', body, { responseType: 'blob' });
      const url  = window.URL.createObjectURL(new Blob([resp.data]));
      const a    = document.createElement('a');
      a.href = url;
      const disp = resp.headers['content-disposition'] || '';
      const match = disp.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
      a.download = match ? decodeURIComponent(match[1].trim().replace(/"/g,'')) : 'documento.docx';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setDocMsg('Documento generato e scaricato!'); setTimeout(()=>setDocMsg(''), 3000);
      loadDocs();
    } catch(err) {
      setDocMsg('✗ ' + (err.response?.data?.error || 'Errore generazione'));
      setTimeout(()=>setDocMsg(''), 4000);
    } finally { setGenerando(false); }
  };

  const scaricaDocumento = (id) => {
    window.open(`${api.defaults.baseURL}/segreteria/docs/${id}/download`, '_blank');
  };

  const eliminaDocumento = async (id) => {
    if (!window.confirm('Eliminare questo documento dall\'archivio?')) return;
    await api.delete(`/segreteria/docs/${id}`);
    loadDocs();
  };

  const loadRichieste = async () => {
    const params = filtroStR ? { stato: filtroStR } : {};
    const r = await api.get('/segreteria/richieste', { params });
    setRichieste(r.data);
  };

  const approvaRichiesta = async (id) => {
    setProcessingR(id);
    try {
      await api.post(`/segreteria/richieste/${id}/approva`, { note_admin: noteAdmin[id] || '' });
      setDocMsg('Richiesta approvata! Socio creato nel Libro Soci.');
      setTimeout(()=>setDocMsg(''), 4000);
      setNoteAdmin(n=>({...n,[id]:''}));
      loadRichieste();
    } catch(err) {
      setDocMsg('✗ ' + (err.response?.data?.error || 'Errore'));
      setTimeout(()=>setDocMsg(''), 4000);
    } finally { setProcessingR(null); }
  };

  const rifiutaRichiesta = async (id) => {
    setProcessingR(id);
    try {
      await api.post(`/segreteria/richieste/${id}/rifiuta`, { note_admin: noteAdmin[id] || '' });
      setDocMsg('Richiesta rifiutata.');
      setTimeout(()=>setDocMsg(''), 3000);
      setNoteAdmin(n=>({...n,[id]:''}));
      loadRichieste();
    } catch(err) {
      setDocMsg('✗ ' + (err.response?.data?.error || 'Errore'));
      setTimeout(()=>setDocMsg(''), 4000);
    } finally { setProcessingR(null); }
  };

  const annoCorrente = new Date().getFullYear();

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'20px' }}>
        <div>
          <h1 style={s.title}>SEGRETERIA ASD</h1>
          <p style={s.sub}>B-Cheers Beach Volley Team ASD — Gestione amministrativa</p>
        </div>
      </div>

      {/* STATS */}
      {stats && tab === 'soci' && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'10px', marginBottom:'20px' }}>
          <div style={s.kpi}><div style={s.kpiVal}>{stats.attivi}</div><div style={s.kpiLab}>SOCI ATTIVI</div></div>
          <div style={s.kpi}><div style={{ ...s.kpiVal, color:'#22C55E' }}>{stats.conQuota}</div><div style={s.kpiLab}>QUOTA PAGATA {annoCorrente}</div></div>
          <div style={{ ...s.kpi, border: stats.senzaQuota > 0 ? '1px solid #F59E0B40' : '1px solid var(--border,#1E1E1E)' }}>
            <div style={{ ...s.kpiVal, color: stats.senzaQuota > 0 ? '#F59E0B' : '#22C55E' }}>{stats.senzaQuota}</div>
            <div style={s.kpiLab}>QUOTA MANCANTE</div>
          </div>
          <div style={s.kpi}><div style={s.kpiVal}>{stats.totale}</div><div style={s.kpiLab}>TOTALE SOCI</div></div>
        </div>
      )}

      {/* DIRETTIVO */}
      {stats?.direttivo?.length > 0 && tab === 'soci' && (
        <div style={{ background:'var(--bg-card,#141414)', border:'1px solid #F4600C30', borderRadius:'10px', padding:'12px 16px', marginBottom:'16px' }}>
          <div style={s.secTitle}>CONSIGLIO DIRETTIVO IN CARICA</div>
          <div style={{ display:'flex', flexWrap:'wrap', gap:'8px' }}>
            {stats.direttivo.map(d => (
              <div key={d.id} style={{ background:'var(--bg-input,#1A1A1A)', borderRadius:'8px', padding:'6px 12px', fontSize: 'var(--font-size-xs)' }}>
                <span style={{ color:'#F4600C', fontWeight:'700', marginRight:'6px' }}>{d.ruolo_direttivo}</span>
                {d.nome} {d.cognome}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* TABS */}
      <div className="schede-scorrevoli" style={{ display:'flex', gap:'4px', marginBottom:'20px', borderBottom:'1px solid var(--border,#1E1E1E)' }}>
        {[['soci','LIBRO SOCI',Users],['verbali','VERBALI',FileText],['documenti','DOCUMENTI',FolderOpen],['richieste','RICHIESTE',UserCheck]].map(([id,label,Icon]) => (
          <button key={id} onClick={() => setTab(id)}
            style={{ display:'flex', alignItems:'center', gap:'6px', padding:'10px 18px', background:'transparent', border:'none',
              borderBottom: tab===id?'2px solid #F4600C':'2px solid transparent',
              color: tab===id?'var(--text)':'#666', fontSize: 'var(--font-size-xs)', fontWeight:'700', letterSpacing:'1px', cursor:'pointer', marginBottom:'-1px' }}>
            <Icon size={14}/> {label}
          </button>
        ))}
      </div>

      {/* ── TAB SOCI ── */}
      {tab === 'soci' && (
        <div>
          <div style={{ display:'flex', gap:'8px', marginBottom:'14px', flexWrap:'wrap', alignItems:'center' }}>
            <select style={s.sel} value={filtroStato} onChange={e=>setFiltroStato(e.target.value)}>
              <option value="">Tutti gli stati</option>
              {STATO_SOCIO.map(v=><option key={v} value={v}>{v}</option>)}
            </select>
            <select style={s.sel} value={filtroTipo} onChange={e=>setFiltroTipo(e.target.value)}>
              <option value="">Tutti i tipi</option>
              {TIPO_SOCIO.map(v=><option key={v} value={v}>{v}</option>)}
            </select>
            <button style={{ ...s.btnPri, marginLeft:'auto' }} onClick={() => { setEditSocio(null); setFormSocio(EMPTY_SOCIO); setShowFormSocio(true); }}>
              <Plus size={14}/> NUOVO SOCIO
            </button>
          </div>

          {/* FORM SOCIO */}
          {showFormSocio && (
            <div style={s.formCard}>
              <div style={s.formTitle}>{editSocio ? 'MODIFICA SOCIO' : 'NUOVO SOCIO'}</div>
              <form onSubmit={salvaSocio}>
                <div style={s.grid3}>
                  <div><label style={s.label}>COGNOME *</label><input style={s.inp} value={formSocio.cognome} onChange={e=>setFormSocio(p=>({...p,cognome:e.target.value}))} required/></div>
                  <div><label style={s.label}>NOME *</label><input style={s.inp} value={formSocio.nome} onChange={e=>setFormSocio(p=>({...p,nome:e.target.value}))} required/></div>
                  <div><label style={s.label}>CODICE FISCALE</label><input style={s.inp} value={formSocio.codice_fiscale} onChange={e=>setFormSocio(p=>({...p,codice_fiscale:e.target.value.toUpperCase()}))}/></div>
                  <div><label style={s.label}>DATA NASCITA</label><input type="date" style={s.inp} value={formSocio.data_nascita} onChange={e=>setFormSocio(p=>({...p,data_nascita:e.target.value}))}/></div>
                  <div><label style={s.label}>LUOGO NASCITA</label><input style={s.inp} value={formSocio.luogo_nascita} onChange={e=>setFormSocio(p=>({...p,luogo_nascita:e.target.value}))}/></div>
                  <div><label style={s.label}>TELEFONO</label><input style={s.inp} value={formSocio.telefono} onChange={e=>setFormSocio(p=>({...p,telefono:e.target.value}))}/></div>
                  <div style={{ gridColumn:'1/-1' }}><label style={s.label}>EMAIL</label><input type="email" style={s.inp} value={formSocio.email} onChange={e=>setFormSocio(p=>({...p,email:e.target.value}))}/></div>
                  <div><label style={s.label}>INDIRIZZO</label><input style={s.inp} value={formSocio.indirizzo} onChange={e=>setFormSocio(p=>({...p,indirizzo:e.target.value}))}/></div>
                  <div><label style={s.label}>CITTÀ</label><input style={s.inp} value={formSocio.citta} onChange={e=>setFormSocio(p=>({...p,citta:e.target.value}))}/></div>
                  <div><label style={s.label}>PROV.</label><input style={{ ...s.inp, width:'60px' }} value={formSocio.provincia} maxLength={2} onChange={e=>setFormSocio(p=>({...p,provincia:e.target.value.toUpperCase()}))}/></div>
                  <div><label style={s.label}>TIPO SOCIO</label><select style={s.inp} value={formSocio.tipo} onChange={e=>setFormSocio(p=>({...p,tipo:e.target.value}))}>{TIPO_SOCIO.map(v=><option key={v} value={v}>{v}</option>)}</select></div>
                  <div><label style={s.label}>DATA ISCRIZIONE</label><input type="date" style={s.inp} value={formSocio.data_iscrizione} onChange={e=>setFormSocio(p=>({...p,data_iscrizione:e.target.value}))}/></div>
                  <div><label style={s.label}>N° TESSERA</label><input style={s.inp} value={formSocio.numero_tessera} onChange={e=>setFormSocio(p=>({...p,numero_tessera:e.target.value}))}/></div>
                  <div><label style={s.label}>STATO</label><select style={s.inp} value={formSocio.stato} onChange={e=>setFormSocio(p=>({...p,stato:e.target.value}))}>{STATO_SOCIO.map(v=><option key={v} value={v}>{v}</option>)}</select></div>
                  <div><label style={s.label}>RUOLO DIRETTIVO</label><select style={s.inp} value={formSocio.ruolo_direttivo||''} onChange={e=>setFormSocio(p=>({...p,ruolo_direttivo:e.target.value||null}))}>{RUOLI_DIRETTIVO.map(v=><option key={v} value={v}>{v||'— nessuno —'}</option>)}</select></div>
                  <div><label style={s.label}>ANNO QUOTA</label><input type="number" style={s.inp} value={formSocio.quota_anno} onChange={e=>setFormSocio(p=>({...p,quota_anno:+e.target.value}))}/></div>
                  <div><label style={s.label}>IMPORTO QUOTA</label><input type="number" step="0.01" style={s.inp} value={formSocio.quota_importo} onChange={e=>setFormSocio(p=>({...p,quota_importo:e.target.value}))}/></div>
                  <div style={{ display:'flex', alignItems:'center', gap:'8px', paddingTop:'20px' }}>
                    <input type="checkbox" id="qp" checked={!!formSocio.quota_pagata} onChange={e=>setFormSocio(p=>({...p,quota_pagata:e.target.checked}))}/>
                    <label htmlFor="qp" style={{ fontSize: 'var(--font-size-sm)', color:'var(--text,#fff)', cursor:'pointer' }}>Quota pagata</label>
                  </div>
                  <div style={{ gridColumn:'1/-1' }}><label style={s.label}>NOTE</label><textarea style={{ ...s.inp, height:'60px', resize:'vertical' }} value={formSocio.note} onChange={e=>setFormSocio(p=>({...p,note:e.target.value}))}/></div>
                </div>
                <div style={{ display:'flex', gap:'8px', justifyContent:'flex-end', marginTop:'12px' }}>
                  <button type="button" style={s.btnSec} onClick={()=>setShowFormSocio(false)}>ANNULLA</button>
                  <button type="submit" style={s.btnPri}><Check size={14}/> SALVA</button>
                </div>
              </form>
            </div>
          )}

          {/* COMUNICAZIONE ESCLUSIONE */}
          {socioComm && (
            <div style={s.formCard}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'12px' }}>
                <div style={s.formTitle}>COMUNICAZIONE ESCLUSIONE — {socioComm.nome} {socioComm.cognome}</div>
                <button style={s.iconBtn} onClick={()=>setSocioComm(null)}><X size={14}/></button>
              </div>
              <div style={s.grid3}>
                <div><label style={s.label}>CANALE</label>
                  <select style={s.inp} value={canaleComm} onChange={e=>setCanaleComm(e.target.value)}>
                    <option value="EMAIL">Email</option>
                    <option value="WHATSAPP">WhatsApp</option>
                    <option value="SMS">SMS</option>
                  </select>
                </div>
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={s.label}>MOTIVO ESCLUSIONE *</label>
                  <textarea style={{ ...s.inp, height:'80px' }} value={motivoEscl} onChange={e=>setMotivoEscl(e.target.value)} placeholder="Descrivere il motivo dell'esclusione..."/>
                </div>
              </div>
              <div style={{ display:'flex', gap:'8px', marginTop:'10px' }}>
                <button style={s.btnSec} onClick={aggiornaTestoEsclusione} disabled={!motivoEscl}>GENERA TESTO</button>
              </div>
              {testoComm && (
                <div style={{ marginTop:'12px' }}>
                  <textarea style={{ ...s.inp, height:'200px', fontFamily:'monospace', fontSize: 'var(--font-size-xs)' }} value={testoComm} onChange={e=>setTestoComm(e.target.value)}/>
                  <div style={{ display:'flex', gap:'8px', marginTop:'8px' }}>
                    <button style={s.btnSec} onClick={()=>navigator.clipboard.writeText(testoComm)}><Mail size={13}/> COPIA</button>
                    {canaleComm === 'WHATSAPP' && <button style={s.btnSec} onClick={()=>window.open(`https://wa.me/?text=${encodeURIComponent(testoComm)}`,'_blank')}><MessageCircle size={13}/> APRI WHATSAPP</button>}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* LISTA SOCI */}
          <div style={{ overflowX:'auto' }}>
            <table className="tabella-schede" style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr style={{ background:'var(--bg-input,#1A1A1A)' }}>
                  {['COGNOME E NOME','TIPO','TESSERA','ISCRITTO DAL','QUOTA','DIRETTIVO','STATO',''].map(h=>(
                    <th key={h} style={s.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading && <tr><td colSpan={8} style={{ textAlign:'center', padding:'30px', color:'#555' }}>Caricamento...</td></tr>}
                {soci.map(socio => {
                  const quotaOk = socio.quota_pagata && socio.quota_anno === annoCorrente;
                  const quotaKo = !socio.quota_pagata && socio.stato === 'ATTIVO';
                  return (
                    <tr key={socio.id} style={{ borderBottom:'1px solid var(--border,#1E1E1E)' }}
                      onMouseEnter={e=>e.currentTarget.style.background='var(--bg-input,#1A1A1A)'}
                      onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                      <td style={s.td}>
                        <div style={{ fontWeight:'600', fontSize: 'var(--font-size-sm)' }}>{socio.cognome} {socio.nome}</div>
                        {socio.email && <div style={{ fontSize: 'var(--font-size-xs)', color:'#555' }}>{socio.email}</div>}
                      </td>
                      <td className="td-meta" data-label="Tipo" style={s.td}><span style={{ fontSize: 'var(--font-size-xs)', color:'#888' }}>{socio.tipo}</span></td>
                      <td className="td-meta" data-label="Tessera" style={s.td}><span style={{ fontSize: 'var(--font-size-xs)', fontFamily:'monospace', color:'#888' }}>{socio.numero_tessera||'—'}</span></td>
                      <td className="td-meta" data-label="Iscritto dal" style={s.td}><span style={{ fontSize: 'var(--font-size-xs)' }}>{fmtData(socio.data_iscrizione)}</span></td>
                      <td className="td-meta" data-label="Quota" style={s.td}>
                        <span style={{ fontSize: 'var(--font-size-xs)', fontWeight:'700', color: quotaOk?'#22C55E':quotaKo?'#F59E0B':'#555' }}>
                          {quotaOk ? `✓ ${annoCorrente}` : quotaKo ? `⚠ mancante` : `${socio.quota_anno||'—'}`}
                        </span>
                      </td>
                      <td className="td-meta" data-label="Direttivo" style={s.td}><span style={{ fontSize: 'var(--font-size-xs)', color:'#F4600C' }}>{socio.ruolo_direttivo||'—'}</span></td>
                      <td className="td-meta" data-label="Stato" style={s.td}>
                        <span style={{ fontSize: 'var(--font-size-xs)', fontWeight:'700', padding:'2px 8px', borderRadius:'4px',
                          color: socio.stato==='ATTIVO'?'#22C55E':socio.stato==='SOSPESO'?'#F59E0B':'#EF4444',
                          background: socio.stato==='ATTIVO'?'#22C55E20':socio.stato==='SOSPESO'?'#F59E0B20':'#EF444420' }}>
                          {socio.stato}
                        </span>
                      </td>
                      <td className="td-azioni" style={{ ...s.td, whiteSpace:'nowrap' }}>
                        <button style={s.iconBtn} title="Modifica" onClick={()=>apriModificaSocio(socio)}><Edit2 size={12}/></button>
                        <button style={{ ...s.iconBtn, color:'#EF4444', marginLeft:'4px' }} title="Comunicazione esclusione" onClick={()=>generaEsclusione(socio)}><AlertCircle size={12}/></button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {soci.length === 0 && !loading && (
              <div style={{ textAlign:'center', padding:'40px', color:'#555' }}>Nessun socio trovato. Aggiungi il primo socio.</div>
            )}
          </div>
        </div>
      )}

      {/* ── TAB RICHIESTE ── */}
      {tab === 'richieste' && (
        <div>
          {docMsg && (
            <div style={{ position:'fixed',top:'20px',right:'20px',background:'#22C55E',color:'#fff',padding:'12px 20px',borderRadius:'8px',fontWeight:'700',fontSize: 'var(--font-size-sm)',zIndex:9999,display:'flex',alignItems:'center',gap:'8px' }}>
              <Check size={14}/> {docMsg}
            </div>
          )}

          {/* Filtro stato */}
          <div style={{ display:'flex',gap:'8px',marginBottom:'20px',alignItems:'center' }}>
            {['PENDENTE','APPROVATA','RIFIUTATA',''].map(s => (
              <button key={s} onClick={()=>setFiltroStR(s)}
                style={{ padding:'7px 14px',borderRadius:'6px',border:'none',cursor:'pointer',fontWeight:'700',fontSize: 'var(--font-size-xs)',letterSpacing:'1px',
                  background: filtroStR===s ? (s==='PENDENTE'?'#F59E0B':s==='APPROVATA'?'#22C55E':s==='RIFIUTATA'?'#EF4444':'#F4600C') : 'var(--bg-input)',
                  color: filtroStR===s ? '#fff' : '#666',
                  border: filtroStR===s ? 'none' : '1px solid var(--border2)',
                }}>
                {s || 'TUTTE'} {!s && ''}
              </button>
            ))}
            <span style={{ marginLeft:'auto',fontSize: 'var(--font-size-xs)',color:'#555' }}>{richieste.length} richieste</span>
          </div>

          {richieste.length === 0 && (
            <div style={{ textAlign:'center',padding:'60px',color:'var(--text-dim)',fontSize: 'var(--font-size-sm)' }}>
              <UserCheck size={40} color='var(--text-dim)' style={{ marginBottom:'12px' }}/>
              <div>Nessuna richiesta {filtroStR ? filtroStR.toLowerCase() : ''}</div>
            </div>
          )}

          <div style={{ display:'flex',flexDirection:'column',gap:'12px' }}>
            {richieste.map(r => {
              const isP = r.stato === 'PENDENTE';
              const stC = { PENDENTE:'#F59E0B', APPROVATA:'#22C55E', RIFIUTATA:'#EF4444' };
              return (
                <div key={r.id} style={{ background:'var(--bg-card,#141414)',border:`1px solid ${stC[r.stato]}30`,borderRadius:'12px',padding:'18px 20px' }}>
                  {/* Header */}
                  <div style={{ display:'flex',alignItems:'center',gap:'12px',marginBottom:'12px' }}>
                    <div style={{ width:'40px',height:'40px',background:'#F4600C20',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
                      <span style={{ color:'#F4600C',fontWeight:'800',fontSize: 'var(--font-size-lg)' }}>{r.cognome?.[0]}</span>
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:'800',fontSize: 'var(--font-size-sm)' }}>{r.cognome} {r.nome}</div>
                      <div style={{ fontSize: 'var(--font-size-xs)',color:'#666' }}>{r.user?.email} · {r.user?.ruolo} · inviata il {fmtData(r.created_at)}</div>
                    </div>
                    <span style={{ background:`${stC[r.stato]}20`,color:stC[r.stato],border:`1px solid ${stC[r.stato]}40`,borderRadius:'6px',padding:'3px 10px',fontSize: 'var(--font-size-xs)',fontWeight:'800' }}>
                      {r.stato}
                    </span>
                  </div>

                  {/* Dati anagrafici */}
                  <div style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'8px 12px',marginBottom:'12px',background:'var(--bg-input)',borderRadius:'8px',padding:'12px' }}>
                    {[['CF',r.codice_fiscale],['Nascita',r.data_nascita?fmtData(r.data_nascita):'—'],['Luogo',r.luogo_nascita],['Tel.',r.telefono],['Indirizzo',r.indirizzo],[`${r.cap||''} ${r.citta||''}`.trim()||null,''],['Tipo',r.tipo_richiesto]].filter(([l,v])=>v).map(([l,v])=>(
                      <div key={l}>
                        <div style={{ fontSize: 'var(--font-size-xs)',letterSpacing:'1px',fontWeight:'700',color:'var(--text-dim)',marginBottom:'1px' }}>{l}</div>
                        <div style={{ fontSize: 'var(--font-size-xs)',color:'var(--text)' }}>{v}</div>
                      </div>
                    ))}
                  </div>

                  {/* Consensi */}
                  <div style={{ display:'flex',gap:'12px',marginBottom:'12px',fontSize: 'var(--font-size-xs)' }}>
                    <span style={{ color:r.accetta_statuto?'#22C55E':'#EF4444',fontWeight:'700' }}>{r.accetta_statuto?'✓':'✗'} Statuto</span>
                    <span style={{ color:r.accetta_privacy?'#22C55E':'#EF4444',fontWeight:'700'  }}>{r.accetta_privacy?'✓':'✗'} Privacy</span>
                    <span style={{ color:r.accetta_immagini?'#22C55E':'#555',fontWeight:'700'    }}>{r.accetta_immagini?'✓':'—'} Immagini</span>
                    {r.note_utente && <span style={{ color:'#888' }}>· Note: {r.note_utente}</span>}
                  </div>

                  {/* Azioni admin */}
                  {isP && (
                    <div style={{ borderTop:'1px solid var(--border2)',paddingTop:'12px',marginTop:'4px' }}>
                      <div style={{ marginBottom:'8px' }}>
                        <label style={{ fontSize: 'var(--font-size-xs)',letterSpacing:'1px',fontWeight:'700',color:'#555',display:'block',marginBottom:'4px' }}>NOTE PER L'UTENTE (opzionale)</label>
                        <input style={s.inp} value={noteAdmin[r.id]||''} onChange={e=>setNoteAdmin(n=>({...n,[r.id]:e.target.value}))} placeholder="Motivazione approvazione o rifiuto..."/>
                      </div>
                      <div style={{ display:'flex',gap:'8px' }}>
                        <button style={{ flex:1,background:'#22C55E',color:'#fff',border:'none',borderRadius:'8px',padding:'10px',fontWeight:'800',fontSize: 'var(--font-size-xs)',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:'6px',opacity:processingR===r.id?0.5:1 }}
                          onClick={()=>approvaRichiesta(r.id)} disabled={!!processingR}>
                          <UserCheck size={14}/> APPROVA — CREA SOCIO
                        </button>
                        <button style={{ flex:1,background:'#EF444420',color:'#EF4444',border:'1px solid #EF444440',borderRadius:'8px',padding:'10px',fontWeight:'800',fontSize: 'var(--font-size-xs)',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:'6px',opacity:processingR===r.id?0.5:1 }}
                          onClick={()=>rifiutaRichiesta(r.id)} disabled={!!processingR}>
                          <X size={14}/> RIFIUTA
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Esito per approvata/rifiutata */}
                  {!isP && (
                    <div style={{ borderTop:'1px solid var(--border2)',paddingTop:'10px',marginTop:'4px',fontSize: 'var(--font-size-xs)',color:'#666' }}>
                      {r.stato === 'APPROVATA' && <span style={{ color:'#22C55E' }}>✓ Approvata il {fmtData(r.approvata_il)} — Socio #{r.socio_id} creato nel Libro Soci</span>}
                      {r.stato === 'RIFIUTATA' && <span style={{ color:'#EF4444' }}>✗ Rifiutata il {fmtData(r.approvata_il)}</span>}
                      {r.note_admin && <div style={{ marginTop:'4px',color:'#888' }}>Note: {r.note_admin}</div>}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── TAB DOCUMENTI ── */}
      {tab === 'documenti' && (
        <div>
          {docMsg && (
            <div style={{ position:'fixed',top:'20px',right:'20px',background:'#22C55E',color:'#fff',padding:'12px 20px',borderRadius:'8px',fontWeight:'700',fontSize: 'var(--font-size-sm)',zIndex:9999,display:'flex',alignItems:'center',gap:'8px' }}>
              <Check size={14}/> {docMsg}
            </div>
          )}

          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px' }}>

            {/* ── COLONNA SINISTRA: template ── */}
            <div>
              <div style={{ fontFamily:"'Barlow Condensed'",fontSize: 'var(--font-size-lg)',fontWeight:'800',letterSpacing:'2px',color:'var(--text)',marginBottom:'14px' }}>
                TEMPLATE ({templates.length})
              </div>

              {/* Form upload */}
              <form onSubmit={uploadTemplate} style={{ background:'var(--bg-card)',border:'1px solid #F4600C30',borderRadius:'10px',padding:'14px',marginBottom:'14px',display:'flex',flexDirection:'column',gap:'10px' }}>
                <div style={s.label}>CARICA NUOVO TEMPLATE .docx</div>
                <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px' }}>
                  <div>
                    <label style={s.label}>NOME DOCUMENTO</label>
                    <input style={s.inp} value={uploadForm.nome} onChange={e=>setUploadForm(f=>({...f,nome:e.target.value}))} placeholder="es. Verbale Assemblea 2026"/>
                  </div>
                  <div>
                    <label style={s.label}>TIPO</label>
                    <select style={s.inp} value={uploadForm.tipo} onChange={e=>setUploadForm(f=>({...f,tipo:e.target.value}))}>
                      {tipiTemplate.map(t=><option key={t.id} value={t.id}>{t.label}</option>)}
                    </select>
                  </div>
                  <div style={{ gridColumn:'1/-1' }}>
                    <label style={s.label}>DESCRIZIONE (opz.)</label>
                    <input style={s.inp} value={uploadForm.descrizione} onChange={e=>setUploadForm(f=>({...f,descrizione:e.target.value}))} placeholder="Descrizione breve"/>
                  </div>
                  <div style={{ gridColumn:'1/-1' }}>
                    <input ref={uploadRef} type="file" accept=".docx" style={{ display:'none' }} onChange={e=>setUploadFile(e.target.files?.[0]||null)}/>
                    <button type="button" style={{ ...s.btnSec, width:'100%', justifyContent:'center' }} onClick={()=>uploadRef.current?.click()}>
                      <Upload size={13}/> {uploadFile ? uploadFile.name : 'SELEZIONA FILE .docx'}
                    </button>
                  </div>
                </div>
                <button type="submit" style={{ ...s.btnPri, justifyContent:'center' }} disabled={!uploadFile || uploading}>
                  <Upload size={13}/> {uploading ? 'CARICAMENTO...' : 'CARICA TEMPLATE'}
                </button>
              </form>

              {/* Lista template */}
              <div style={{ display:'flex',flexDirection:'column',gap:'6px' }}>
                {templates.length === 0 && <div style={{ color:'#555',fontSize: 'var(--font-size-sm)',padding:'20px 0' }}>Nessun template caricato.</div>}
                {templates.map(t => {
                  const tipoInfo = tipiTemplate.find(x=>x.id===t.tipo);
                  return (
                    <div key={t.id} style={{ background:'var(--bg-card)',border:'1px solid var(--border,#1E1E1E)',borderRadius:'8px',padding:'10px 14px',display:'flex',alignItems:'center',gap:'10px' }}>
                      <div style={{ flex:1 }}>
                        <div style={{ fontWeight:'700',fontSize: 'var(--font-size-sm)' }}>{t.nome}</div>
                        <div style={{ fontSize: 'var(--font-size-xs)',color:'#555',marginTop:'2px' }}>{tipoInfo?.label || t.tipo}</div>
                        {t.descrizione && <div style={{ fontSize: 'var(--font-size-xs)',color:'#666',fontStyle:'italic' }}>{t.descrizione}</div>}
                      </div>
                      <button style={s.iconBtn} title="Scarica template" onClick={()=>scaricaTemplate(t.id)}><Download size={12}/></button>
                      <button style={{ ...s.iconBtn,color:'#EF4444' }} title="Elimina" onClick={()=>eliminaTemplate(t.id,t.nome)}><Trash2 size={12}/></button>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* ── COLONNA DESTRA: genera + archivio ── */}
            <div>
              {/* GENERA */}
              <div style={{ fontFamily:"'Barlow Condensed'",fontSize: 'var(--font-size-lg)',fontWeight:'800',letterSpacing:'2px',color:'var(--text)',marginBottom:'14px' }}>
                GENERA DOCUMENTO
              </div>
              <form onSubmit={generaDocumento} style={{ background:'var(--bg-card)',border:'1px solid #F4600C30',borderRadius:'10px',padding:'14px',marginBottom:'20px',display:'flex',flexDirection:'column',gap:'10px' }}>
                {(() => {
                  const selTmpl = templates.find(t=>String(t.id)===String(genForm.template_id));
                  const tipoInfo = tipiTemplate.find(x=>x.id===selTmpl?.tipo);
                  const fonteSocio   = tipoInfo?.fonte === 'socio';
                  const fonteVerbale = tipoInfo?.fonte === 'verbale';
                  return (
                    <>
                      <div>
                        <label style={s.label}>TEMPLATE *</label>
                        <select style={s.inp} value={genForm.template_id} onChange={e=>setGenForm(f=>({...f,template_id:e.target.value,socio_id:'',verbale_id:''}))} required>
                          <option value="">— seleziona template —</option>
                          {tipiTemplate.map(tipo => {
                            const gruppo = templates.filter(t=>t.tipo===tipo.id);
                            if (!gruppo.length) return null;
                            return <optgroup key={tipo.id} label={tipo.label}>{gruppo.map(t=><option key={t.id} value={t.id}>{t.nome}</option>)}</optgroup>;
                          })}
                        </select>
                      </div>
                      {fonteSocio && (
                        <div>
                          <label style={s.label}>SOCIO (opz.)</label>
                          <select style={s.inp} value={genForm.socio_id} onChange={e=>setGenForm(f=>({...f,socio_id:e.target.value}))}>
                            <option value="">— solo variabili ASD —</option>
                            {soci.filter(x=>x.stato==='ATTIVO').map(so=><option key={so.id} value={so.id}>{so.cognome} {so.nome}</option>)}
                          </select>
                          {!soci.length && <div style={{ fontSize: 'var(--font-size-xs)',color:'#F59E0B',marginTop:'4px' }}>Vai al tab SOCI per caricare i soci</div>}
                        </div>
                      )}
                      {fonteVerbale && (
                        <div>
                          <label style={s.label}>VERBALE (opz.)</label>
                          <select style={s.inp} value={genForm.verbale_id} onChange={e=>setGenForm(f=>({...f,verbale_id:e.target.value}))}>
                            <option value="">— solo variabili ASD —</option>
                            {verbali.map(v=><option key={v.id} value={v.id}>{v.numero} — {TIPO_VERBALE.find(t=>t.id===v.tipo)?.label} del {fmtData(v.data)}</option>)}
                          </select>
                        </div>
                      )}
                      {selTmpl && (
                        <div style={{ background:'var(--bg-input)',borderRadius:'8px',padding:'10px 12px',fontSize: 'var(--font-size-xs)',color:'#666',lineHeight:'1.6' }}>
                          <div style={{ fontWeight:'700',color:'#888',marginBottom:'4px' }}>VARIABILI DISPONIBILI:</div>
                          {selTmpl.variabili ? JSON.parse(selTmpl.variabili).map(v=><code key={v} style={{ background:'#ffffff10',borderRadius:'3px',padding:'1px 4px',marginRight:'4px',display:'inline-block',marginBottom:'2px' }}>{`{{${v}}}`}</code>) : '—'}
                        </div>
                      )}
                      <button type="submit" style={{ ...s.btnPri, justifyContent:'center' }} disabled={!genForm.template_id || generando}>
                        <Download size={13}/> {generando ? 'GENERAZIONE...' : 'GENERA E SCARICA'}
                      </button>
                    </>
                  );
                })()}
              </form>

              {/* ARCHIVIO */}
              <div style={{ fontFamily:"'Barlow Condensed'",fontSize: 'var(--font-size-lg)',fontWeight:'800',letterSpacing:'2px',color:'var(--text)',marginBottom:'10px' }}>
                ARCHIVIO DOCUMENTI
              </div>
              <div style={{ display:'flex',gap:'8px',marginBottom:'10px' }}>
                <select style={s.sel} value={docFiltroAnno} onChange={e=>setDocFiltroAnno(+e.target.value)}>
                  {[2024,2025,2026,2027].map(y=><option key={y} value={y}>{y}</option>)}
                </select>
                <select style={s.sel} value={docFiltroTipo} onChange={e=>setDocFiltroTipo(e.target.value)}>
                  <option value="">Tutti i tipi</option>
                  {tipiTemplate.map(t=><option key={t.id} value={t.id}>{t.label}</option>)}
                </select>
              </div>
              <div style={{ display:'flex',flexDirection:'column',gap:'6px' }}>
                {documenti.length === 0 && <div style={{ color:'#555',fontSize: 'var(--font-size-sm)',padding:'20px 0' }}>Nessun documento generato per questo periodo.</div>}
                {documenti.map(d => (
                  <div key={d.id} style={{ background:'var(--bg-card)',border:'1px solid var(--border,#1E1E1E)',borderRadius:'8px',padding:'10px 14px',display:'flex',alignItems:'center',gap:'10px' }}>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:'700',fontSize: 'var(--font-size-sm)' }}>{d.nome}</div>
                      <div style={{ fontSize: 'var(--font-size-xs)',color:'#555',marginTop:'2px' }}>
                        {tipiTemplate.find(x=>x.id===d.tipo)?.label || d.tipo}
                        {d.socio && <span style={{ color:'#888',marginLeft:'8px' }}>· {d.socio.cognome} {d.socio.nome}</span>}
                        <span style={{ color:'#555',marginLeft:'8px' }}>· {new Date(d.created_at).toLocaleDateString('it-IT')}</span>
                      </div>
                    </div>
                    <button style={s.iconBtn} title="Scarica" onClick={()=>scaricaDocumento(d.id)}><Download size={12}/></button>
                    <button style={{ ...s.iconBtn,color:'#EF4444' }} title="Elimina" onClick={()=>eliminaDocumento(d.id)}><Trash2 size={12}/></button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── TAB VERBALI ── */}
      {tab === 'verbali' && (
        <div>
          <div style={{ display:'flex', gap:'8px', marginBottom:'14px', flexWrap:'wrap', alignItems:'center' }}>
            <select style={s.sel} value={filtroAnnoV} onChange={e=>setFiltroAnnoV(+e.target.value)}>
              {[2022,2023,2024,2025,2026,2027].map(y=><option key={y} value={y}>{y}</option>)}
            </select>
            <select style={s.sel} value={filtroTipoV} onChange={e=>setFiltroTipoV(e.target.value)}>
              <option value="">Tutti i tipi</option>
              {TIPO_VERBALE.map(v=><option key={v.id} value={v.id}>{v.label}</option>)}
            </select>
            <button style={{ ...s.btnPri, marginLeft:'auto' }} onClick={() => { setEditVerbale(null); setFormVerbale(EMPTY_VERBALE); setShowFormVerbale(true); }}>
              <Plus size={14}/> NUOVO VERBALE
            </button>
          </div>

          {/* FORM VERBALE */}
          {showFormVerbale && (
            <div style={s.formCard}>
              <div style={s.formTitle}>{editVerbale ? 'MODIFICA VERBALE' : 'NUOVO VERBALE'}</div>
              <form onSubmit={salvaVerbale}>
                <div style={s.grid3}>
                  <div><label style={s.label}>TIPO *</label>
                    <select style={s.inp} value={formVerbale.tipo} onChange={e=>setFormVerbale(p=>({...p,tipo:e.target.value}))}>
                      {TIPO_VERBALE.map(v=><option key={v.id} value={v.id}>{v.label} (preavviso {v.preavviso}gg)</option>)}
                    </select>
                  </div>
                  <div><label style={s.label}>DATA *</label><input type="date" style={s.inp} value={formVerbale.data} onChange={e=>setFormVerbale(p=>({...p,data:e.target.value}))} required/></div>
                  <div><label style={s.label}>ORA (I conv.)</label><input type="time" style={s.inp} value={formVerbale.ora_inizio} onChange={e=>setFormVerbale(p=>({...p,ora_inizio:e.target.value}))}/></div>
                  <div><label style={s.label}>ORA (II conv.)</label><input type="time" style={s.inp} value={formVerbale.ora_fine} onChange={e=>setFormVerbale(p=>({...p,ora_fine:e.target.value}))}/></div>
                  <div><label style={s.label}>MODALITÀ</label>
                    <select style={s.inp} value={formVerbale.modalita} onChange={e=>setFormVerbale(p=>({...p,modalita:e.target.value}))}>
                      <option value="PRESENZA">In presenza</option>
                      <option value="TELEMATICA">Telematica (Google Meet/Zoom)</option>
                      <option value="MISTA">Mista</option>
                    </select>
                  </div>
                  <div style={{ gridColumn:'1/-1' }}><label style={s.label}>LUOGO</label><input style={s.inp} value={formVerbale.luogo} onChange={e=>setFormVerbale(p=>({...p,luogo:e.target.value}))} placeholder="es. Sede sociale - Via Macon 30, Lecco"/></div>
                  <div><label style={s.label}>PRESIDENTE SEDUTA</label><input style={s.inp} value={formVerbale.presidente} onChange={e=>setFormVerbale(p=>({...p,presidente:e.target.value}))}/></div>
                  <div><label style={s.label}>SEGRETARIO</label><input style={s.inp} value={formVerbale.segretario} onChange={e=>setFormVerbale(p=>({...p,segretario:e.target.value}))}/></div>
                  <div><label style={s.label}>STATO</label>
                    <select style={s.inp} value={formVerbale.stato} onChange={e=>setFormVerbale(p=>({...p,stato:e.target.value}))}>
                      <option value="BOZZA">Bozza</option>
                      <option value="DEFINITIVO">Definitivo</option>
                    </select>
                  </div>
                  <div style={{ gridColumn:'1/-1' }}><label style={s.label}>ORDINE DEL GIORNO</label><textarea style={{ ...s.inp, height:'80px', resize:'vertical' }} value={formVerbale.ordine_del_giorno} onChange={e=>setFormVerbale(p=>({...p,ordine_del_giorno:e.target.value}))} placeholder="1. Approvazione rendiconto 2024&#10;2. Rinnovo cariche sociali&#10;3. Varie ed eventuali"/></div>
                  <div><label style={s.label}>PRESENTI (lista nomi)</label><textarea style={{ ...s.inp, height:'70px', resize:'vertical' }} value={formVerbale.presenti_nomi} onChange={e=>setFormVerbale(p=>({...p,presenti_nomi:e.target.value}))}/></div>
                  <div><label style={s.label}>N° PRESENTI</label><input type="number" style={s.inp} value={formVerbale.presenti_numero} onChange={e=>setFormVerbale(p=>({...p,presenti_numero:+e.target.value}))}/></div>
                  <div><label style={s.label}>ASSENTI</label><textarea style={{ ...s.inp, height:'70px', resize:'vertical' }} value={formVerbale.assenti_nomi} onChange={e=>setFormVerbale(p=>({...p,assenti_nomi:e.target.value}))}/></div>
                  <div style={{ gridColumn:'1/-1' }}><label style={s.label}>DELEGHE</label><input style={s.inp} value={formVerbale.deleghe} onChange={e=>setFormVerbale(p=>({...p,deleghe:e.target.value}))} placeholder="es. Mario Rossi delega Katia Contardo"/></div>
                  <div style={{ display:'flex', alignItems:'center', gap:'8px', paddingTop:'16px' }}>
                    <input type="checkbox" id="qprim" checked={!!formVerbale.quorum_prima} onChange={e=>setFormVerbale(p=>({...p,quorum_prima:e.target.checked}))}/>
                    <label htmlFor="qprim" style={{ fontSize: 'var(--font-size-sm)', cursor:'pointer' }}>Quorum raggiunto in I convocazione</label>
                  </div>
                  <div style={{ gridColumn:'1/-1' }}><label style={s.label}>DELIBERE</label><textarea style={{ ...s.inp, height:'100px', resize:'vertical' }} value={formVerbale.delibere} onChange={e=>setFormVerbale(p=>({...p,delibere:e.target.value}))} placeholder="L'assemblea delibera all'unanimità..."/></div>
                  <div style={{ gridColumn:'1/-1' }}><label style={s.label}>NOTE</label><textarea style={{ ...s.inp, height:'60px', resize:'vertical' }} value={formVerbale.note} onChange={e=>setFormVerbale(p=>({...p,note:e.target.value}))}/></div>
                </div>
                <div style={{ display:'flex', gap:'8px', justifyContent:'flex-end', marginTop:'12px' }}>
                  <button type="button" style={s.btnSec} onClick={()=>setShowFormVerbale(false)}>ANNULLA</button>
                  <button type="submit" style={s.btnPri}><Check size={14}/> SALVA</button>
                </div>
              </form>
            </div>
          )}

          {/* CONVOCAZIONE */}
          {showConvocazione && verbaleAperto && (
            <div style={s.formCard}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'12px' }}>
                <div style={s.formTitle}>GENERA CONVOCAZIONE — {verbaleAperto.numero}</div>
                <button style={s.iconBtn} onClick={()=>setShowConvocazione(false)}><X size={14}/></button>
              </div>
              <div style={{ display:'flex', gap:'8px', marginBottom:'12px' }}>
                {['EMAIL','WHATSAPP','SMS'].map(c=>(
                  <button key={c} style={{ ...s.btnSec, ...(canaleConv===c?{border:'1px solid #F4600C',color:'#F4600C'}:{}) }}
                    onClick={()=>aggiornaCanaleConv(c)}>
                    {c==='EMAIL'?<Mail size={13}/>:<MessageCircle size={13}/>} {c}
                  </button>
                ))}
              </div>
              {loadingConv ? <div style={{ color:'#555', padding:'20px' }}>Generazione testo...</div> : (
                <>
                  <textarea style={{ ...s.inp, height:'280px', fontFamily:'monospace', fontSize: 'var(--font-size-xs)', width:'100%' }}
                    value={testoConv} onChange={e=>setTestoConv(e.target.value)}/>
                  <div style={{ display:'flex', gap:'8px', marginTop:'10px' }}>
                    <button style={s.btnSec} onClick={copiaConvocazione}><Mail size={13}/> COPIA TESTO</button>
                    {canaleConv === 'WHATSAPP' && (
                      <button style={s.btnSec} onClick={apriWhatsapp}><MessageCircle size={13}/> APRI WHATSAPP</button>
                    )}
                    {canaleConv === 'EMAIL' && (
                      <button style={s.btnSec} onClick={()=>window.open(`mailto:?subject=${encodeURIComponent('Convocazione '+verbaleAperto.tipo)}&body=${encodeURIComponent(testoConv)}`)}>
                        <Mail size={13}/> APRI CLIENT EMAIL
                      </button>
                    )}
                  </div>
                  <p style={{ fontSize: 'var(--font-size-xs)', color:'#555', marginTop:'8px' }}>
                    ⚠ Ricorda: la convocazione deve essere inviata almeno {TIPO_VERBALE.find(t=>t.id===verbaleAperto.tipo)?.preavviso||10} giorni prima dell'adunanza (Art. 14 Statuto).
                  </p>
                </>
              )}
            </div>
          )}

          {/* LISTA VERBALI */}
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            {verbali.length === 0 && <div style={{ textAlign:'center', padding:'40px', color:'#555' }}>Nessun verbale trovato.</div>}
            {verbali.map(v => {
              const tipoInfo = TIPO_VERBALE.find(t=>t.id===v.tipo);
              return (
                <div key={v.id} style={{ background:'var(--bg-card,#141414)', border:'1px solid var(--border,#1E1E1E)', borderRadius:'10px', padding:'14px 18px' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
                    <div style={{ flex:1 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'4px' }}>
                        <span style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-lg)', fontWeight:'800', color:'#F4600C' }}>{v.numero}</span>
                        <span style={{ fontSize: 'var(--font-size-xs)', fontWeight:'600' }}>{tipoInfo?.label}</span>
                        <span style={{ fontSize: 'var(--font-size-xs)', color:'#888' }}>{fmtData(v.data)}{v.ora_inizio ? ` ore ${v.ora_inizio}` : ''}</span>
                        <span style={{ fontSize: 'var(--font-size-xs)', padding:'2px 7px', borderRadius:'4px', fontWeight:'700',
                          color: v.stato==='DEFINITIVO'?'#22C55E':'#F59E0B',
                          background: v.stato==='DEFINITIVO'?'#22C55E20':'#F59E0B20' }}>{v.stato}</span>
                      </div>
                      {v.luogo && <div style={{ fontSize: 'var(--font-size-xs)', color:'#555' }}>📍 {v.luogo}</div>}
                      {v.ordine_del_giorno && <div style={{ fontSize: 'var(--font-size-xs)', color:'#666', marginTop:'4px', whiteSpace:'pre-line' }}>{v.ordine_del_giorno.slice(0,150)}{v.ordine_del_giorno.length>150?'...':''}</div>}
                    </div>
                    <div style={{ display:'flex', gap:'6px', flexShrink:0 }}>
                      <button style={s.btnSec} onClick={()=>generaConvocazione(v)}><Mail size={13}/> CONVOCA</button>
                      <button style={s.iconBtn} onClick={()=>apriModificaVerbale(v)}><Edit2 size={13}/></button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  title:    { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' },
  sub:      { color:'var(--text-muted,#888)', fontSize: 'var(--font-size-sm)', marginTop:'4px' },
  btnPri:   { display:'flex', alignItems:'center', gap:'6px', background:'#F4600C', color:'#fff', border:'none', borderRadius:'8px', padding:'9px 14px', fontSize: 'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' },
  btnSec:   { display:'flex', alignItems:'center', gap:'6px', background:'var(--bg-input,#1A1A1A)', color:'var(--text,#fff)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'8px', padding:'8px 12px', fontSize: 'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' },
  iconBtn:  { background:'var(--bg-input,#1A1A1A)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'6px', padding:'5px 8px', color:'var(--text-muted,#888)', cursor:'pointer', display:'inline-flex', alignItems:'center' },
  sel:      { background:'var(--bg-input,#1A1A1A)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'8px', padding:'8px 12px', color:'var(--text,#fff)', fontSize: 'var(--font-size-xs)', outline:'none' },
  kpi:      { background:'var(--bg-card,#141414)', border:'1px solid var(--border,#1E1E1E)', borderRadius:'10px', padding:'14px 18px' },
  kpiVal:   { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', color:'var(--text,#fff)' },
  kpiLab:   { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'#555', marginTop:'2px' },
  formCard: { background:'var(--bg-card,#141414)', border:'1px solid #F4600C40', borderRadius:'12px', padding:'18px', marginBottom:'16px' },
  formTitle:{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-lg)', fontWeight:'800', color:'#F4600C', marginBottom:'14px' },
  grid3:    { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'10px' },
  label:    { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'#555', display:'block', marginBottom:'4px' },
  inp:      { background:'var(--bg-input,#1A1A1A)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'8px', padding:'8px 12px', color:'var(--text,#fff)', fontSize: 'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
  th:       { padding:'10px 12px', textAlign:'left', fontSize: 'var(--font-size-xs)', fontWeight:'700', letterSpacing:'1px', color:'#555', borderBottom:'1px solid var(--border,#1E1E1E)', whiteSpace:'nowrap' },
  td:       { padding:'10px 12px', fontSize: 'var(--font-size-sm)', verticalAlign:'middle' },
  secTitle: { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'#555', marginBottom:'8px' },
};
